import defaultCode from '@/assets/default-code.txt';
var code=defaultCode.replace("git-samples-server",process.env.VUE_APP_GIT_URL)
export default code


